import React, { useEffect, useState, useRef } from 'react';
import './GameOver.css';
import { useAuth } from '../AuthContext';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';

function GameOver({ score, round, gridSize, difficulty, onBackToMenu, onPlayAgain }) {
  const { currentUser } = useAuth();
  const [scoreSaved, setScoreSaved] = useState(false);
  const [saveError, setSaveError] = useState(null);
  const saveAttemptedRef = useRef(false);

  useEffect(() => {
    // Prevent double save in React Strict Mode
    if (currentUser && score > 0 && !scoreSaved && !saveAttemptedRef.current) {
      saveAttemptedRef.current = true;
      saveScore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser, score]);

  const saveScore = async () => {
    try {
      const scoreData = {
        userId: currentUser.uid,
        playerName: currentUser.displayName || 'Anonymous',
        score: score,
        round: round - 1,
        gridSize: gridSize,
        difficulty: difficulty,
        timestamp: new Date()
      };
      
      console.log('Saving score:', scoreData);
      
      const docRef = await addDoc(collection(db, 'scores'), scoreData);
      
      console.log('Score saved successfully with ID:', docRef.id);
      setScoreSaved(true);
    } catch (error) {
      console.error('Error saving score:', error);
      setSaveError(error.message);
      saveAttemptedRef.current = false; // Allow retry on error
    }
  };

  return (
    <div className="game-over">
      <div className="game-over-content">
        <h1 className="game-over-title">Game Over!</h1>
        
        <div className="stats">
          <div className="stat-item">
            <span className="stat-label">Final Score</span>
            <span className="stat-value">{score}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Rounds Completed</span>
            <span className="stat-value">{round - 1}</span>
          </div>
        </div>

        {currentUser && scoreSaved && score > 0 && (
          <p className="score-saved">✓ Score saved to leaderboard!</p>
        )}

        {currentUser && saveError && (
          <p className="save-error">⚠ Failed to save score: {saveError}</p>
        )}

        {!currentUser && score > 0 && (
          <p className="login-prompt">Login to save your score!</p>
        )}

        <p className="game-over-message">
          {score === 0 
            ? "Don't give up! Try again!"
            : score < 100 
            ? "Good effort! Keep practicing!"
            : score < 300
            ? "Great job! You're getting better!"
            : "Amazing! You're a color master!"
          }
        </p>

        <div className="button-group">
          <button className="play-again-button" onClick={onPlayAgain}>
            Play Again
          </button>
          <button className="menu-button" onClick={onBackToMenu}>
            Back to Menu
          </button>
        </div>
      </div>
    </div>
  );
}

export default GameOver;
